import { AudioLines, Calculator, LayoutDashboard, ListChecks, SlidersHorizontal, UserSquare, Video } from 'lucide-vue-next'
import MicIcon from '~icons/material-symbols/mic'
import VoiceIcon from '~icons/material-symbols/graphic-eq'
import { SETTING_TABS_UPLOAD, useAdminEntry, useSettingEntry, type NavItem } from '../../../base/src/config/nav'
import { useI18n } from '../../../base/src/composables/useI18n'
import MuseIntro from '../views/Intro.vue'
import navEn from '../locales/en'
import navZh from '../locales/zh'

export const useMuseMenu = () => {
  const getMenu = (): NavItem[] => {
    const { t } = useI18n({ zh: navZh, en: navEn })
    return [
      // 普通用户可见：工作台、声音（音色模板 / 声音合成）、视频（形象 / 生成）
      {
        key: 'MuseHome',
        label: t('muse.nav.workspace'),
        shortLabel: t('muse.nav.workspace'),
        icon: LayoutDashboard,
        path: '/user/muse/dashboard',
      },
      {
        key: 'MuseVoice',
        label: t('muse.nav.voice'),
        shortLabel: t('muse.nav.voice'),
        icon: VoiceIcon,
        items: [
          { key: 'MuseVoiceTemplate', label: t('muse.nav.voiceTemplate'), icon: AudioLines, path: '/user/muse/voiceTemplate' },
          { key: 'MuseVoiceSynth', label: t('muse.nav.voiceSynth'), icon: MicIcon, path: '/user/muse/voice' },
        ],
      },
      {
        key: 'MuseVideo',
        label: t('muse.nav.video'),
        shortLabel: t('muse.nav.video'),
        icon: Video,
        items: [
          { key: 'MuseAvatar', label: t('muse.nav.avatar'), icon: UserSquare, path: '/user/muse/avatar' },
          { key: 'MuseAvatarGenerate', label: t('muse.nav.avatarGenerate'), icon: Video, path: '/user/muse/avatarGenerate' },
        ],
      },
      // 仅管理员可见：管理（仪表盘 / 数字人形象 / 合成任务 / 接口配置 + 账户充值 + base 固定项）
      useAdminEntry({
        withPay: true,
        items: [
          { key: 'MuseAdminDashboard', label: t('muse.nav.adminDashboard'), icon: LayoutDashboard, path: '/muse/dashboard' },
          { key: 'MuseAdminAvatar', label: t('muse.nav.adminAvatar'), icon: UserSquare, path: '/muse/avatarPreset' },
          { key: 'MuseAdminTask', label: t('muse.nav.adminTask'), icon: ListChecks, path: '/muse/task' },
          { key: 'MuseAdminModel', label: t('muse.nav.adminModel'), icon: SlidersHorizontal, path: '/muse/modelConfig' },
          { key: 'MuseAdminPricing', label: t('muse.nav.adminPricing'), icon: Calculator, path: '/muse/pricing' },
        ],
      }),
      useSettingEntry('/muse', SETTING_TABS_UPLOAD, false),
    ]
  }
  return { getMenu }
}

export const useMuseModule = () => ({
  key: 'muse',
  label: 'Muse',
  homePath: '/user/muse/dashboard',
  pathPrefixes: ['/muse', '/user/muse'],
  adminPaths: ['/muse'],
  accountSections: ['account', 'info', 'password', 'recharge'],
  landing: MuseIntro,
  landingTitle: () => useI18n({ zh: navZh, en: navEn }).t('muse.intro.pageTitle'),
  getMenu: useMuseMenu().getMenu,
})
